import {
  CREATE_PART,
  CREATE_PART_SUCCESS,
  DELETE_PART,
  DELETE_PART_SUCCESS,
  GET_PART,
  GET_PART_SUCCESS,
  GET_PARTS,
  GET_PARTS_SUCCESS,
  UPDATE_PART,
  UPDATE_PART_SUCCESS,
  UPDATE_PARTS_PAGINATION,
} from '../constants/Parts';

const initialState = {
  parts: [],
  part: {
    id: null,
    name: '',
    part_numbers: [],
  },
  search: '',
  perPage: 10,
  from: 0,
  to: 0,
  page: 1,
  loading: false,
};

const parts = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTS:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
        loading: true,
      };
    case GET_PARTS_SUCCESS:
      return {
        ...state,
        parts: action.parts,
        total: action.total,
        from: action.from,
        to: action.to,
        loading: false,
      };
    case CREATE_PART:
      return {
        ...state,
        loading: false,
      };
    case CREATE_PART_SUCCESS:
      return {
        ...state,
        part: action.part,
        loading: false,
      };
    case GET_PART:
      return {
        ...state,
        loading: false,
      };
    case GET_PART_SUCCESS:
      return {
        ...state,
        part: action.part,
        loading: false,
      };
    case UPDATE_PART:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_PART_SUCCESS:
      return {
        ...state,
        part: action.part,
        loading: false,
      };
    case DELETE_PART:
      return {
        ...state,
        loading: false,
      };
    case DELETE_PART_SUCCESS:
      return {
        ...state,
        part: initialState.part,
        loading: false,
      };
    case UPDATE_PARTS_PAGINATION:
      return {
        ...state,
        search: action.search,
        perPage: action.perPage,
        page: action.page,
      };
    default:
      return state;
  }
};

export default parts;
